import { ChevronDown, Building2, Shield, Users } from 'lucide-react';
import { Button } from './ui/button';

export const HeroSection = () => {
  const scrollToServices = () => {
    const element = document.querySelector('#servicios');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const element = document.querySelector('#contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="hero-section relative min-h-screen flex items-center"
      style={{
        backgroundImage: `url('https://images.unsplash.com/photo-1769721209842-e46c60e7fbf9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwYnVpbGRpbmclMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzcwNDE0MzUxfDA&ixlib=rb-4.1.0&q=85')`,
      }}
    >
      <div className="hero-overlay" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-4xl">
          {/* Label */}
          <div className="flex items-center gap-3 mb-6 animate-fade-in">
            <div className="gold-line" />
            <span className="font-manrope uppercase tracking-widest text-xs font-bold text-[#BF9000]">
              Desde 2019 construyendo excelencia
            </span>
          </div>

          {/* Main Headline */}
          <h1
            data-testid="hero-headline"
            className="font-oswald text-3xl sm:text-5xl lg:text-7xl font-bold text-white uppercase tracking-tight leading-tight mb-6 animate-slide-up"
          >
            Construyendo el
            <span className="text-[#92D050]"> Futuro </span>
            de México
          </h1>

          {/* Subheadline */}
          <p
            data-testid="hero-subheadline"
            className="font-manrope text-lg sm:text-xl text-slate-300 leading-relaxed mb-10 max-w-2xl animate-slide-up"
            style={{ animationDelay: '200ms' }}
          >
            Ingeniería civil y construcción de vanguardia. Desarrollamos proyectos 
            comerciales, industriales y habitacionales con excelencia técnica y 
            compromiso sostenible.
          </p>

          {/* CTA Buttons */}
          <div
            className="flex flex-col sm:flex-row gap-4 mb-16 animate-slide-up"
            style={{ animationDelay: '400ms' }}
          >
            <Button
              onClick={scrollToServices}
              data-testid="hero-cta-services"
              className="bg-[#385723] text-white hover:bg-[#2a421b] px-8 py-6 font-oswald uppercase tracking-wider text-lg transition-all duration-300 hover:shadow-lg"
            >
              Nuestros Servicios
            </Button>
            <Button
              onClick={scrollToContact}
              data-testid="hero-cta-contact"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-[#385723] px-8 py-6 font-oswald uppercase tracking-wider text-lg transition-all duration-300"
            >
              Solicitar Cotización
            </Button>
          </div>

          {/* Stats */}
          <div
            className="grid grid-cols-3 gap-8 pt-8 border-t border-white/20 animate-slide-up"
            style={{ animationDelay: '600ms' }}
          >
            <div className="flex items-center gap-3">
              <Building2 className="w-8 h-8 text-[#92D050]" />
              <div>
                <p className="font-oswald text-2xl sm:text-3xl font-bold text-white">6+</p>
                <p className="font-manrope text-xs sm:text-sm text-slate-400 uppercase tracking-wider">Años de Experiencia</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Shield className="w-8 h-8 text-[#92D050]" />
              <div>
                <p className="font-oswald text-2xl sm:text-3xl font-bold text-white">100%</p>
                <p className="font-manrope text-xs sm:text-sm text-slate-400 uppercase tracking-wider">Calidad Garantizada</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Users className="w-8 h-8 text-[#92D050]" />
              <div>
                <p className="font-oswald text-2xl sm:text-3xl font-bold text-white">50+</p>
                <p className="font-manrope text-xs sm:text-sm text-slate-400 uppercase tracking-wider">Proyectos Exitosos</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button
          onClick={scrollToServices}
          data-testid="scroll-indicator"
          className="text-white/70 hover:text-[#92D050] transition-colors"
        >
          <ChevronDown className="w-8 h-8" />
        </button>
      </div>
    </section>
  );
};
